<template>
    <div class="wrapper-content w-100">
        <div class="no-search-found position-relative text-center">
        <LmSvgIcon
          wrapperClass="d-flex h-100 justify-content-center align-items-center flex-column"
          width="8em"
          icon="LmNoDataIcon"
          :text="title ? title : $t('not_found_h1')"
        />
        </div>
    </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="sass" scoped>
.no-search-found
  padding: 4%
  flex-grow: 1
  img
    margin: 0 auto 30px auto
    display: block
    @media(max-width: $md)
      max-width: 50%
  h1,
  h2
    color: $primaryFontThemeColor
    max-width: 700px
    margin: 0 auto
    text-align: center
    @media(max-width: $md)
      min-width: 100px
  h1
    font-size: 24px
    margin-bottom: 10px
    @media(max-width: $md)
      font-size: 18px
  h2
    font-size: 18px
    @media(max-width: $md)
      font-size: 14px
  .wrap-circle
    display: flex
    justify-content: center
    align-items: center
    margin: 0 auto
    padding-bottom: 30px
    font-size: 7em
    color: #cccccc
    border-radius: 50%
</style>
